//AboutUs.View.js
define(
   'AboutPearlgreen.View'
,   [
      'about_pearlgreen.tpl'
   ,   'Backbone'
   ,   'jQuery'
   ]
,   function (
      about_pearlgreen_tpl
   ,   Backbone
   ,   jQuery
   )
{
   'use strict';

   //@class Address.List.View List profile's addresses @extend Backbone.View
   return Backbone.View.extend({

      template: about_pearlgreen_tpl
	,     title: _('About Us').translate() 

   ,   events: {
	   
      }
   ,   initialize : function()
		{	
		  
		}
	,	getBreadcrumbPages: function()
		{
			return {
				href:'/about-us'
			,	text:'ABOUT US'
			};
		}	

   ,   getContext: function ()
      {
         return {
            //@property {String} myNewModuleContextVar
            myNewModuleContextVar: 'myVariable'
         };
      }
   });
});
